import type { ReactNode } from 'react'

import { Accordion, Breadcrumbs, SelectionCard } from '@graftcode/design-system'

import { SCROLL_MARGIN_DESKTOP } from '../../const'
import type { CardData } from '../../types'
import { LibrariesOnboarding } from '../LibrariesOnboarding'

import { InstallationSection } from './InstallationSection'

import styles from './DesktopCardView.module.scss'

export function DesktopCardView({
  path,
  installationCardKey,
  technologies,
  suggestedTechnologies,
  selectedTechnology,
  installationTabs,
  graftabilityReport,
  libraryData,
  onTechnologyChange,
  onConnectionStringGenerator,
  breadcrumbs,
  onBreadcrumbClick,
  list,
  details,
  openAccordions,
}: CardData) {
  const showInstallation = path.length > 0
  const isEmptyRoot = path.length === 0 && list.length === 0

  if (isEmptyRoot) {
    return <LibrariesOnboarding />
  }

  return (
    <>
      {showInstallation && (
        <InstallationSection
          installationCardKey={installationCardKey}
          technologies={technologies}
          suggestedTechnologies={suggestedTechnologies}
          selectedTechnology={selectedTechnology}
          tabs={installationTabs}
          libraryData={libraryData}
          graftabilityReport={graftabilityReport}
          onTechnologyChange={onTechnologyChange}
          onConnectionStringGenerator={onConnectionStringGenerator}
        />
      )}
      <div className={styles.header}>
        <Breadcrumbs
          className={styles.breadcrumbs}
          childType={({ children, href, ...props }: { children: ReactNode; href?: string }) => (
            <button
              type="button"
              {...props}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onBreadcrumbClick(href)
              }}
            >
              {children}
            </button>
          )}
          items={breadcrumbs}
          size="l"
        />
      </div>
      <div className={styles.list}>
        {list.map((card) => (
          <SelectionCard key={card.id} {...card}>
            {card.children}
          </SelectionCard>
        ))}
      </div>
      {details.map((accordion) => {
        const isOpen = Boolean(openAccordions.includes(accordion.id))
        const { id, titleSlot, content, onCollapseChange } = accordion
        const anchorId = `anchor-${encodeURIComponent(id)}`

        return (
          <div
            key={id}
            id={anchorId}
            style={{ scrollMarginTop: SCROLL_MARGIN_DESKTOP, scrollMarginBottom: SCROLL_MARGIN_DESKTOP }}
          >
            <Accordion
              id={id}
              className={styles.accordion}
              titleSlot={titleSlot}
              content={content}
              isOpen={isOpen}
              onCollapseChange={onCollapseChange}
            />
          </div>
        )
      })}
    </>
  )
}
